export default {
	crmAuthGet: '/admin/customer-match/crm-auth-get', //触发目标客户匹配使用资格
	industyList: '/admin/customer-match/industry-list', //行业列表
	industryUserList: '/admin/customer-match/industry-user-list', //行业在营销列表
	industryReport: '/admin/customer-match/download/industry-report', //行业报告下载
	industryPackage: '/admin/customer-match/download/industry-package', //行业包下载
	industryPackageAds: '/admin/customer-match/upload/industry-package', //触发数据同步Ads(单个)
	industryPackageAllAds: '/admin/customer-match/upload/industry-package-all', //触发数据同步Ads(全部)
	industryDetails: '/admin/customer-match/industry-details/{industryId}', //行业详情接口

	getTopic: '/admin/topic', //托词列表
	postTopic: '/admin/topic', //新增托词
	putTopic: '/admin/topic', //修改托词状态
	deleteTopic: '/admin/topic/{id}', //删除托词
	searchKeyword: '/admin/topic/get_keyword', //查询拓词

	list: '/admin/online-plan', //上线方案列表
	onlinePlan: '/admin/online-plan/extension', //拓展词列表
	execl: '/admin/online-plan/excel/{serviceSiteId}', //关键词导出
	details: '/admin/online-plan/details', //获取新户上线方案详情
	extension: '/admin/online-plan/excel/extension/{serviceSiteId}', //拓展词导出
	addKeywordsRecommend: '/admin/online-plan/addKeywordsRecommend', //测试

	editMonitoringRules: '/admin/monitor/rule/editservicedata', // 编辑监测规则
	monitoringRuleConfig: '/admin/monitor/rule/listruleitem', // 监测规则配置列表
	updateCost: '/admin/monitor/budget', // 修改询盘和预算成本
	warningType: '/admin/monitor/rule/listruletype', // 预警类别列表
	activeList: '/admin/monitor/active/list', //客户活跃列表
	inactiveList: '/admin/monitor/inactive/list', //客户非活跃列表
	warnList: '/admin/monitor/rule/listremind', //预警提醒列表
	signSolve: '/admin/monitor/rule/signsolve/{id}', //标记为已解决
	warningLog: '/admin/monitor/rule/listmonitorlog', //预警日志
	ruleTypeList: '/admin/monitor/rule/listruletype', //预警类型列表
	serviceDetail: '/admin/monitor/details', // 服务单详情-全球赢服务单详情数据
	serviceAdvertising: '/admin/monitor/details/campaign', // 服务单详情-广告系列数据
	serviceInquiryConsule: '/admin/monitor/details/consumption', // 服务单详情-询盘/消耗数据
	setserviceStatus: '/admin/monitor/status', // 设置服务单状态
	operatList: '/enum/getadslogoperationenum', //全部操作类型
	warningItemList: '/admin/monitor/rule/listruleitembyname', //预警项
	modifyRemark: '/admin/monitor/remark/{id}', //非活跃列表-修改备注
	budgetCost: '/admin/monitor/detalis/kpi', // 获取预算和成本
	ruleTreeList: '/admin/monitor/rule/listrule', //获取预警项的级联数据

	searchDataView: '/admin/search_term/over_view', // 搜索词数据总览
	searchList: '/admin/search_term/list', // 搜索词列表
	searchTermsHistoryList: '/admin/search_term/history_list', // 提交历史列表
	searchTermsCharts: '/admin/search_term/chart_list', // 单个搜索词图表

	// 广告报告下载
	getReportList: '/admin/report/list', // 报告记录列表
	addManualReport: '/admin/report/manual-report', // 创建手动报告
	deleteReport: '/admin/report/{id}', // 删除报告
	getReportDetails: '/admin/report/{id}', // 报告详情
	reportRemarkSave: '/admin/report/{id}', // 修改备注
	customerMetrics: '/admin/report/customer-metrics/{type}/{id}/', // 日期/设备/网络报告
	inquiryMetrics: '/admin/report/inquiry-report/{id}', // 询盘报告
	campaignMetrics: '/admin/report/campaign-metrics/{id}', // 广告系列报告
	geoMetrics: '/admin/report/geo-metrics/{id}', // 国家地区报告
	keywordMetrics: '/admin/report/keyword-metrics/{id}', // 关键词报告
	searchTermMetrics: '/admin/report/search-term-metrics/{id}', // 搜索词报告
	reportDownloadDetail: '/admin/report/download-detail', // 新增下载详细记录
	regenerateReport: '/admin/report/regenerate-report/{id}', // 重新生成手动报告

	// 广告报告预览接口
	customerMetricsPreview: '/admin/report/customer-metrics/show', // 日期/设备/网络报告预览
	inquiryMetricsPreview: '/admin/report/inquiry-report/show', // 询盘报告预览
	campaignMetricsPreview: '/admin/report/campaign-metrics/show', // 广告系列报告预览
	geoMetricsPreview: '/admin/report/geo-metrics/show', // 国家地区报告预览
	keywordMetricsPreview: '/admin/report/keyword-metrics/show', // 关键词报告预览
	searchTermMetricsPreview: '/admin/report/search-term-metrics/show', // 索词报告预览

	// 广告报告下载-模板
	templateChooseList: '/admin/report/template/choose-list', // 模板筛选列表
	templateRelationList: '/admin/report/template/relation-list', // 模板与客户关系列表
	addTemplateRelation: '/admin/report/template/relation', // 新增模板与客户挂钩关系
	getTemplateList: '/admin/report/template/list', // 模板列表
	getTemplateDetail: '/admin/report/template/details/{id}', // 模板详情
	addReportTemplate: '/admin/report/template', // 新增or修改模板
	deleteReportTemplate: '/admin/report/template/{id}', // 删除模板
	reportTemplateDimension: '/admin/report/template/dimension', // 修改模板报告配置
	templateReportDetails: '/admin/report/template/report-details/{detailsId}', // 模板报告配置详情

	// 账户管理
	getAdsAccountList: '/iglobalwin-ads-api/account/list', // ads账户列表
	getCampaignList: '/iglobalwin-ads-api/campaign/list', // 获取广告系列列表
	getCampaignBaseList: '/iglobalwin-ads-api/campaign/base/list', // 获取广告系列基础列表
	getCampaignDetail: '/iglobalwin-ads-api/campaign/detail/{id}', // 获取广告系列详情
	getCampaignStatus: '/iglobalwin-ads-api/campaign/status', // 修改广告系状态
	getAdgroupList: '/iglobalwin-ads-api/adgroup/list', // 获取广告组列表
	getAdgroupBaseList: '/iglobalwin-ads-api/adgroup/base/list', // 获取广告组基本列表
	getAdgroupDetail: '/iglobalwin-ads-api/adgroup/detail/{id}', // 获取广告组详情
	getAdgroupStatus: '/iglobalwin-ads-api/adgroup/status', // 修改广告组状态
	getAdgroupAdList: '/iglobalwin-ads-api/adgroupad/list', // 获取广告列表
	getAdgroupAdStatus: '/iglobalwin-ads-api/adgroupad/status', // 修改广告状态
	getKeywordList: '/iglobalwin-ads-api/keyword/list', // 获取关键词列表
	getKeywordStatus: '/iglobalwin-ads-api/keyword/status', // 修改关键词状态
	getCustomfieldUserList: '/iglobalwin-ads-api/customfields/user/list/{type}', // 获取当前用户自定义列列表
	insertCustomfieldList: '/iglobalwin-ads-api/customfields/insert', // 添加当前用户自定义列列表
	getCustomfieldList: '/iglobalwin-ads-api/customfields/list/{type}', // 获取自定义列列表

	getLanguageList: '/iglobalwin-ads-api/dict/language/list', // 获取语言列表
	getGeoList: '/iglobalwin-ads-api/dict/geo/group/list', // 获取国家地区列表
	getChannelType: '/iglobalwin-ads-api/dict/channel/type', // 广告系列目标类型
	getMatchType: '/iglobalwin-ads-api/dict/match/type', // 关键字匹配类型
	addCampaign: '/iglobalwin-ads-api/campaign/add', // 添加广告系列
	addAdgroup: '/iglobalwin-ads-api/adgroup/add', // 添加广告组
	addAdgroupad: '/iglobalwin-ads-api/adgroupad/add', // 添加广告
	addKeyword: '/iglobalwin-ads-api/keyword/add', // 添加关键词
	getKeywordProduct: '/iglobalwin-ads-api/keyword/product', // 根据链接获取产品关键词
	getKeywordCheck: '/iglobalwin-ads-api/keyword/check', // 关键词检测
	getKeywordHistorical: '/iglobalwin-ads-api/keyword/historical', // 关键词保存-历史关键词
	getServiceDomain: '/iglobalwin-ads-api/tservice/domain', // 获取服务单域名
	getCampaignDevice: '/iglobalwin-ads-api/campaign/device', // 获取设备报价
	getCampaignRemove: '/iglobalwin-ads-api/campaign/remove', // 广告系列移除状态
	getAdgroupRemove: '/iglobalwin-ads-api/adgroup/remove', // 广告组移除状态
	getAdgroupadRemove: '/iglobalwin-ads-api/adgroupad/remove', // 广告移除状态
	getCampaignEditDetail: '/iglobalwin-ads-api/campaign/edit/detail/{id}', // 广告系列编辑详情
	getCampaignUpdate: '/iglobalwin-ads-api/campaign/update', // 广告系列修改
	getAdgroupEditDetail: '/iglobalwin-ads-api/adgroup/edit/detail/{id}', // 广告组编辑详情
	getAdgroupUpdate: '/iglobalwin-ads-api/adgroup/update', // 广告组修改
	getAdgroupadUpdate: '/iglobalwin-ads-api/adgroupad/update', // 广告修改
	getAdgroupadEditDetail: '/iglobalwin-ads-api/adgroupad/detail/{id}', // 广告编辑详情

	// 广告自动检测
	detectionAccountList: '/detection/account/list', // ads账户列表
	detectionList: '/detection/list', // 广告语检测列表
	detectionSummary: '/detection/summary/{serviceId}', // 广告检测结果汇总
	getDetectionConfig: '/detection/config/{serviceId}', // 获取广告检测配置
	setDetectionConfig: '/detection/update/config', // 修改广告检测配置
	manualDetection: '/detection/manual/{serviceId}', // 广告语手动检测
	detectionReplace: '/detection/replace', // 广告语替换
	detectionIgnore: '/detection/ignore', // 广告语忽略
	detectionManualSingle: '/detection/manual/single/{id}', // 广告语手动检测-单条API
	aiOptimizeSwitch: '/detection/ai-optimize/switch', // AI优化开关

	// AI关键词判定
	keywordRunTask: '/detection-search-keyword/run/task', // 执行检测任务
	keywordTaskData: '/detection-search-keyword/task/{serviceId}', // 获取检测任务结果
	addSearchKeyword: '/detection-search-keyword/add', // 添加关键词
	excludeSearchKeyword: '/detection-search-keyword/exclude', // 排除关键词
	igonoreSearchKeyword: '/detection-search-keyword/igonore', // 忽略关键词
	getSharedList: '/detection-search-keyword/shared/list/{serviceId}', // 获取排除列表

	// 账户余额匹配
	balanceMatchImport: '/admin/customer-balance-match/import', // 导入Excel匹配客户余额
	balanceMatchList: '/admin/customer-balance-match/list', // 明细列表
};
